import { render, staticRenderFns } from "./Technicaltransformation.vue?vue&type=template&id=3f4d785e&scoped=true&"
import script from "./Technicaltransformation.vue?vue&type=script&lang=js&"
export * from "./Technicaltransformation.vue?vue&type=script&lang=js&"
import style0 from "./Technicaltransformation.vue?vue&type=style&index=0&id=3f4d785e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d785e",
  null
  
)

export default component.exports